/* eslint-env node */
import { isProd } from "../utils/helpers";

const envConfig = {
  API_URL: process.env.REACT_APP_API_URL || "https://api-prod.seniorlife.ai/",
  USER_API_URL:
    process.env.REACT_APP_USER_API_URL || "https://api.seniorlife.io/",

  DASHBOARD_URL:
    process.env.REACT_APP_DASHBOARD_URL ||
    (isProd
      ? "https://testpersons.seniorlife.io"
      : "https://testpersons.dev.seniorlife.io"),

  S3_BUCKET:
    process.env.REACT_APP_S3_BUCKET || (isProd ? "hma-prd" : "hma-dev"),

  AWS_REGION: process.env.REACT_APP_AWS_REGION || "ap-northeast-1",
};

export default envConfig;
